import { ReactNode, createContext, default as React, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { WorkerTypesReducer } from "../reducers/WorkerTypesReducer";

const WorkerTypesContext = createContext({
	state: WorkerTypesReducer.getInitialState(),
	actions: WorkerTypesReducer.actions,
});

export const useWorkerTypesContext = () => useContext(WorkerTypesContext);

export const WorkerTypesProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: WorkerTypesReducer.getInitialState(),
		reducers: WorkerTypesReducer.caseReducers,
	});

	return (
		<WorkerTypesContext.Provider value={{ state, actions }}>
			{children}
		</WorkerTypesContext.Provider>
	);
};
